import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center bg-paper px-6">
      <Seo
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Head back home for landscaping, lawn care, drainage, lighting, retaining walls, pavers and handyman services in Tampa Bay."
        path="/404"
      />
      <div className="text-center" data-testid="notfound-page">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
          404
        </div>
        <h1 className="font-display font-black text-5xl sm:text-6xl text-[#1c1917] mt-3 tracking-tighter">
          Page not found.
        </h1>
        <p className="mt-4 text-[#57534e] max-w-md mx-auto">
          Looks like that page swung out of frame. Let&rsquo;s get you back home.
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex items-center px-6 h-12 rounded-full bg-[#16a34a] hover:bg-[#15803d] text-white font-bold transition"
          data-testid="notfound-home-link"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
